import React from 'react';
import { Box, Container, Typography, Grid, Paper } from '@mui/material';
import { motion } from 'framer-motion';
import './BackendTechnologies.css';

const technologies = {
  "Frameworks": [
    { name: "Laravel", logo: "/assets/tech-logos/laravel.svg" },
    { name: "Python", logo: "/assets/tech-logos/python.png" },
    { name: "Django", logo: "/assets/tech-logos/django.svg" },
    { name: "Node.js", logo: "/assets/tech-logos/nodejs.png" },
    // { name: "Go", logo: "/assets/tech-logos/golang.png" },
    { name: "Express", logo: "/assets/tech-logos/express.svg" },
    { name: "Nest.js", logo: "/assets/tech-logos/nestjs.svg" },
    // { name: "Rails", logo: "/assets/tech-logos/rails.svg" }
  ],
  "Databases": [
    { name: "MySQL", logo: "/assets/tech-logos/mysql.png" },
    { name: "PostgreSQL", logo: "/assets/tech-logos/postgresql.png" },
    { name: "MongoDB", logo: "/assets/tech-logos/mongodb.png" }
  ],
  "Key-Value Storages": [
    { name: "Redis", logo: "/assets/tech-logos/redis.png" },
    { name: "Amazon DynamoDB", logo: "/assets/tech-logos/aws.png" }
  ],
  // "Search Engines": [
  //   { name: "Elasticsearch", logo: "/assets/tech-logos/elasticsearch.svg" },
  //   { name: "Sphinx", logo: "/assets/tech-logos/sphinx.svg" }
  // ],
  "Other Libraries": [
    { name: "Socket.io", logo: "/assets/tech-logos/socketio.svg" },
    { name: "AWS Lambda", logo: "/assets/tech-logos/aws.png" },
    { name: "RabbitMQ", logo: "/assets/tech-logos/rabbitmq.svg" },
    { name: "SignalR", logo: "/assets/tech-logos/signalr.svg" },
    { name: "Apache Kafka", logo: "/assets/tech-logos/kafka.svg" }
  ],
  // "Videos": [
  //   { name: "FFmpeg", logo: "/assets/tech-logos/ffmpeg.svg" },
  //   { name: "GStreamer", logo: "/assets/tech-logos/gstreamer.svg" },
  //   { name: "WebRTC", logo: "/assets/tech-logos/webrtc.svg" },
  //   { name: "Jitsi", logo: "/assets/tech-logos/jitsi.svg" }
  // ]
};

const BackendTechnologies = () => {
  const containerVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6 }
    }
  };

  return (
    <Box className="backend-technologies-section">
      <Container maxWidth="lg">
        <motion.div
          initial="hidden"
          animate="visible"
          variants={containerVariants}
        >
          <Typography variant="h2" className="section-title" gutterBottom>
            BACKEND
          </Typography>

          {Object.entries(technologies).map(([category, techs]) => (
            <Box key={category} className="technology-category">
              <Typography variant="h4" className="category-title" gutterBottom>
                {category}
              </Typography>
              <Grid container spacing={3}>
                {techs.map((tech) => (
                  <Grid item xs={6} sm={4} md={3} lg={2} key={tech.name}>
                    <motion.div variants={itemVariants}>
                      <Paper elevation={2} className="technology-card">
                        <img
                          src={tech.logo}
                          alt={tech.name}
                          className="technology-logo"
                        />
                        <Typography variant="subtitle1" className="technology-name">
                          {tech.name}
                        </Typography>
                      </Paper>
                    </motion.div>
                  </Grid>
                ))}
              </Grid>
            </Box>
          ))}
        </motion.div>
      </Container>
    </Box>
  );
};

export default BackendTechnologies; 